const TaskWorkbench = () => import(/* webpackChunkName: "taskManage" */'@/components/pages/taskManage/Workbench');
const TaskWorkflowDetail = () => import(/* webpackChunkName: "taskManage" */'@/components/pages/taskManage/TaskWorkflowDetail');
const TaskCreatePage = () => import(/* webpackChunkName: "taskManage" */'@/components/pages/taskManage/TaskCreatePage');
const Layout = () => import(/* webpackChunkName: "base" */'@/components/common/Layout');
const RequestWorkbench = () => import(/* webpackChunkName: "requestManage" */'@/components/pages/requestManage/Workbench');
const RequestWorkflowDetail = () => import(/* webpackChunkName: "requestManage" */'@/components/pages/requestManage/RequestWorkflowDetail');
const RequestCreatePage = () => import(/* webpackChunkName: "requestManage" */'@/components/pages/requestManage/RequestCreatePage');
const RequestPreviewPage = () => import(/* webpackChunkName: "requestManage" */'@/components/pages/requestManage/RequestPreviewPage');
const EventServiceDesk = () => import(/* webpackChunkName: "eventManage" */'@/components/pages/eventManage/ServiceDesk');
const EventWorkbench = () => import(/* webpackChunkName: "eventManage" */'@/components/pages/eventManage/Workbench');
const EventCallRecord = () => import(/* webpackChunkName: "eventManage" */'@/components/pages/eventManage/CallRecord');
const EventWorkflowDetail = () => import(/* webpackChunkName: "eventManage" */'@/components/pages/eventManage/EventWorkflowDetail');
const EventWorkflowCreateDetail = () => import(/* webpackChunkName: "eventManage" */'@/components/pages/eventManage/EventWorkflowCreateDetail');
const ScoreboardManage = () => import(/* webpackChunkName: "eventManage" */'@/components/pages/eventManage/ScoreboardManage');
const PublicScoreboardManage = () => import(/* webpackChunkName: "eventManage" */'@/components/pages/eventManage/PublicScoreboardManage');
const ScoreboardDetail = () => import(/* webpackChunkName: "eventManage" */'@/components/pages/eventManage/ScoreboardDetail');
const RelateAssets = () => import(/* webpackChunkName: "eventManage" */'@/components/pages/eventManage/RelateAssets');
const CreateRelevantCallPage = () => import(/* webpackChunkName: "eventManage" */'@/components/pages/eventManage/CreateRelevantCallPage');
const ProblemWorkbench = () => import(/* webpackChunkName: "problemManage" */'@/components/pages/problemManage/Workbench');
const ProblemWorkflowDetail = () => import(/* webpackChunkName: "problemManage" */'@/components/pages/problemManage/ProblemWorkflowDetail');
const ProblemCreatePage = () => import(/* webpackChunkName: "problemManage" */'@/components/pages/problemManage/ProblemCreatePage');
const ChangeWorkbench = () => import(/* webpackChunkName: "changeManage" */'@/components/pages/changeManage/Workbench');
const ChangeWorkflowDetail = () => import(/* webpackChunkName: "changeManage" */'@/components/pages/changeManage/ChangeWorkflowDetail');
const ChangeCreatePage = () => import(/* webpackChunkName: "changeManage" */'@/components/pages/changeManage/ChangeCreatePage');
const ReleaseWorkbench = () => import(/* webpackChunkName: "releaseManage" */'@/components/pages/releaseManage/Workbench');
const ReleaseWorkflowDetail = () => import(/* webpackChunkName: "releaseManage" */'@/components/pages/releaseManage/ReleaseWorkflowDetail');
const ReleaseCreatePage = () => import(/* webpackChunkName: "releaseManage" */'@/components/pages/releaseManage/ReleaseCreatePage');
const ChangeWorkflowCalendar = () => import(/* webpackChunkName: "changeManage" */'@/components/pages/changeManage/ChangeWorkflowCalendar');

import relevant from './relevant';

export default [
  {
    path: '/work-order',
    name: 'workOrder',
    meta: {
      isEvent: true,
      roles: ['WF_EVENT_QUERY',
              'WF_REQUEST_QUERY',
              'WF_TASK_QUERY',
              'WF_PROBLEM_QUERY',
              'WF_CHANGE_QUERY',
              'WF_RELEASE_QUERY'
            ],
      title: '工单管理',
      icon: 'workOrder',
    },
    component: Layout,
    children: [
      // {
      //   path: 'event-service-desk',
      //   name: 'eventServiceDesk',
      //   meta: {
      //     isServiceDesk: true,
      //     roles: [],
      //     title: '服务台',
      //     activeMenu: '/event-manage/event-service-desk/',
      //     componentName: 'EventServiceDesk',
      //     breadcrumb: [
      //       {
      //         name: '服务台',
      //         path: '/event-manage/event-service-desk'
      //       }
      //     ]
      //   },
      //   component: EventServiceDesk
      // },
      {
        path: 'event-bench',
        name: 'eventBench',
        meta: {
          // isNotServiceDesk: true,
          roles: ['WF_EVENT_QUERY'],
          title: '事件管理',
          activeMenu: '/event-manage/event-bench/',
          componentName: 'EventWorkbench',
          breadcrumb: [
            {
              name: '事件管理',
              path: '/event-manage/event-bench'
            }
          ]
        },
        component: EventWorkbench
      },
      {
        path: 'event-bench/edit-event-workflow/:id',
        props: true,
        name: 'editEventWorkflow',
        meta: {
          roles: [],
          title: '处理事件',
          hidden: true,
          // activeMenu: '/event-manage/event-bench',
          componentName: 'EventWorkflowDetail',
          breadcrumb: [
            {
              name: '事件管理',
              path: '/event-manage/event-bench'
            },
            {
              name: '处理事件',
              path: '/event-manage/edit-event-workflow/:id'
            }
          ]
        },
        component: EventWorkflowDetail
      },
      {
        path: 'event-bench/create-event-workflow',
        name: 'createEventWorkflow',
        meta: {
          roles: ['WF_EVENT_ADD'],
          title: '新建事件单据',
          hidden: true,
          // activeMenu: '/event-manage/event-bench/',
          componentName: 'EventWorkflowCreateDetail',
          breadcrumb: [
            {
              name: '事件管理',
              path: '/event-manage/event-bench'
            },
            {
              name: '新建事件单据',
              path: '/event-manage/create-event-workflow'
            }
          ]
        },
        component: EventWorkflowCreateDetail
      },
      {
        path: 'event-bench/create-event-workflow/:callId',
        name: 'createEventWorkflowByCall',
        meta: {
          roles: ['WF_EVENT_ADD'],
          title: '来电建单',
          hidden: true,
          // activeMenu: '/event-manage/event-bench',
          componentName: 'EventWorkflowCreateDetail',
          breadcrumb: [
            {
              name: '事件管理',
              path: '/event-manage/event-bench'
            },
            {
              name: '来电建单',
              path: '/event-manage/create-event-workflow/:callId'
            }
          ]
        },
        component: EventWorkflowCreateDetail
      },
      {
        path: 'event-bench/scoreboard-manage/:menuType',
        name: 'scoreboardManage',
        meta: {
          roles: ['WF_EVENT_CUSTOM_SCOREBOARD_QUERY'],
          title: '事件记分牌管理',
          hidden: true,
          // activeMenu: '/event-manage/event-bench/',
          componentName: 'ScoreboardManage',
          breadcrumb: [
            {
              name: '事件管理',
              path: '/event-manage/event-bench'
            },
            {
              name: '事件记分牌管理',
              path: '/event-manage/scoreboard-manage/:menuType'
            }
          ]
        },
        component: ScoreboardManage
      },
      {
        path: 'event-bench/public-scoreboard-manage/:menuType',
        name: 'publicScoreboardManage',
        meta: {
          title: '公开记分牌',
          hidden: true,
          // activeMenu: '/event-manage/event-bench/',
          componentName: 'PublicScoreboardManage',
          breadcrumb: [
            {
              name: '事件管理',
              path: '/event-manage/event-bench'
            },
            {
              name: '公开记分牌',
              path: '/event-manage/public-scoreboard-manage/:menuType'
            }
          ]
        },
        component: PublicScoreboardManage
      },
      {
        path: 'event-bench/check-scoreboard/:id',
        name: 'checkScoreboard',
        meta: {
          title: '查看公开记分牌',
          hidden: true,
          // activeMenu: '/event-manage/event-bench/',
          componentName: 'ScoreboardDetail',
          breadcrumb: [
            {
              name: '事件管理',
              path: '/event-manage/event-bench'
            },
            {
              name: '查看公开记分牌',
              path: '/event-manage/check-scoreboard/:id'
            }
          ]
        },
        component: ScoreboardDetail
      },
      {
        path: 'event-bench/create-scoreboard/:menuType',
        name: 'createScoreboard',
        meta: {
          title: '新建事件记分牌',
          hidden: true,
          // activeMenu: '/event-manage/event-bench/',
          componentName: 'ScoreboardDetail',
          breadcrumb: [
            {
              name: '事件管理',
              path: '/event-manage/event-bench'
            },
            {
              name: '新建事件记分牌',
              path: '/event-manage/create-scoreboard/:menuType'
            }
          ]
        },
        component: ScoreboardDetail
      },
      {
        path: 'event-bench/edit-scoreboard/:id',
        name: 'editScoreboard',
        meta: {
          title: '编辑事件记分牌',
          hidden: true,
          // activeMenu: '/event-manage/event-bench/',
          componentName: 'ScoreboardDetail',
          breadcrumb: [
            {
              name: '事件管理',
              path: '/event-manage/event-bench'
            },
            {
              name: '编辑事件记分牌',
              path: '/event-manage/edit-scoreboard/:id'
            }
          ]
        },
        component: ScoreboardDetail
      },
      {
        path: 'event-bench/:id/relate-assets',
        name: 'relateAssets',
        props: true,
        meta: {
          roles: ['WF_EVENT_ASSOCIATED_ASSETS'],
          title: '关联资产',
          hidden: true,
          activeMenu: '/event-manage/event-bench/',
          // componentName: 'RelateAssets',
          breadcrumb: [
            {
              name: '事件管理',
              path: '/event-manage/event-bench'
            },
            {
              name: '关联资产',
              path: '/event-manage/:id/relate-assets'
            }
          ]
        },
        component: RelateAssets
      },
      {
        path: 'event-bench/:id/create-relevant-call-page',
        name: 'createRelevantCallPage',
        props: true,
        meta: {
          roles: ['WF_EVENT_RELEVANT_CALL_ADD'],
          title: '关联来电记录',
          hidden: true,
          // activeMenu: '/event-manage/event-bench/',
          componentName: 'CreateRelevantCallPage',
          breadcrumb: [
            {
              name: '事件管理',
              path: '/event-manage/event-bench'
            },
            {
              name: '关联来电记录',
              path: '/event-manage/:id/create-relevant-call-page'
            }
          ]
        },
        component: CreateRelevantCallPage
      },
      {
        path: 'request-bench',
        name: 'requestBench',
        meta: {
          roles: ['WF_REQUEST_QUERY'],
          title: '请求管理',
          icon: 'approval-center',
          activeMenu: '/request-manage/request-bench/',
          componentName: 'RequestWorkbench',
          breadcrumb: [
            {
              name: '请求管理',
              path: '/request-manage/request-bench'
            }
          ]
        },
        component: RequestWorkbench
      },
      {
        path: 'request-bench/edit-request-workflow/:id',
        props: true,
        name: 'editRequestWorkflow',
        meta: {
          roles: ['WF_REQUEST_DETAIL'],
          title: '处理请求',
          hidden: true,
          // activeMenu: '/request-manage/request-bench/',
          componentName: 'RequestWorkflowDetail',
          breadcrumb: [
            {
              name: '请求管理',
              path: '/request-manage/request-bench'
            },
            {
              name: '处理请求',
              path: '/request-manage/edit-request-workflow/:id'
            }
          ]
        },
        component: RequestWorkflowDetail
      },
      {
        path: 'request-bench/create-request-workflow/:entryId',
        name: 'createRequestWorkflow',
        meta: {
          roles: ['WF_REQUEST_CREATE'],
          title: '新建请求单据',
          hidden: true,
          // activeMenu: '/request-manage/request-bench/',
          componentName: 'RequestCreatePage',
          breadcrumb: [
            {
              name: '请求管理',
              path: '/request-manage/request-bench'
            },
            {
              name: '新建请求单据',
              path: '/request-manage/create-request-workflow/:entryId'
            }
          ]
        },
        component: RequestCreatePage
      },
      {
        path: 'request-bench/preview-request-workflow/:entryId',
        name: 'previewRequestWorkflow',
        meta: {
          // roles: [],
          title: '预览请求单据',
          hidden: true,
          // activeMenu: '/request-manage/request-bench/',
          componentName: 'RequestPreviewPage',
          breadcrumb: [
            {
              name: '请求管理',
              path: '/request-manage/request-bench'
            },
            {
              name: '预览请求单据',
              path: '/request-manage/preview-request-workflow/:entryId'
            }
          ]
        },
        component: RequestPreviewPage
      },
      {
        path: 'task-bench',
        name: 'taskBench',
        meta: {
          roles: ['WF_TASK_QUERY'],
          title: '任务管理',
          icon: 'task-manage',
          activeMenu: '/task-manage/task-bench/',
          componentName: 'TaskWorkbench',
          breadcrumb: [
            {
              name: '任务管理',
              path: '/task-manage/task-bench'
            }
          ]
        },
        component: TaskWorkbench
      },
      {
        path: 'task-bench/edit-task-workflow/:id',
        props: true,
        name: 'editTaskWorkflow',
        meta: {
          roles: ['WF_TASK_DETAIL_QUERY'],
          title: '处理任务',
          hidden: true,
          activeMenu: '/task-manage/task-bench/',
          componentName: 'TaskWorkflowDetail',
          breadcrumb: [
            {
              name: '任务管理',
              path: '/task-manage/task-bench'
            },
            {
              name: '处理任务任务',
              path: '/task-manage/edit-task-workflow/:id'
            }
          ]
        },
        component: TaskWorkflowDetail
      },
      {
        path: 'task-bench/create-task-workflow',
        name: 'createTaskWorkflow',
        meta: {
          roles: ['WF_TASK_ADD'],
          title: '新建任务单据',
          hidden: true,
          activeMenu: '/task-manage/task-bench/',
          componentName: 'TaskCreatePage',
          breadcrumb: [
            {
              name: '任务管理',
              path: '/task-manage/task-bench'
            },
            {
              name: '新建任务单据',
              path: '/task-manage/create-task-workflow'
            }
          ]
        },
        component: TaskCreatePage
      },
      {
        path: 'problem-bench',
        name: 'problemBench',
        meta: {
          roles: ['WF_PROBLEM_QUERY'],
          title: '问题管理',
          icon: 'problem-manage',
          activeMenu: '/problem-manage/problem-bench/',
          componentName: 'ProblemWorkbench',
          breadcrumb: [
            {
              name: '问题管理',
              path: '/problem-manage/problem-bench'
            }
          ]
        },
        component: ProblemWorkbench
      },
      {
        path: 'problem-bench/edit-problem-workflow/:id',
        props: true,
        name: 'editProblemWorkflow',
        meta: {
          roles: ['WF_PROBLEM_DETAIL_QUERY'],
          title: '处理问题',
          hidden: true,
          activeMenu: '/problem-manage/problem-bench/',
          componentName: 'ProblemWorkflowDetail',
          breadcrumb: [
            {
              name: '问题管理',
              path: '/problem-manage/problem-bench'
            },
            {
              name: '处理问题',
              path: '/problem-manage/edit-problem-workflow/:id'
            }
          ]
        },
        component: ProblemWorkflowDetail
      },
      {
        path: 'problem-bench/create-problem-workflow',
        name: 'createProblemWorkflow',
        meta: {
          roles: ['WF_PROBLEM_ADD'],
          title: '新建问题单据',
          hidden: true,
          activeMenu: '/problem-manage/problem-bench/',
          componentName: 'ProblemCreatePage',
          breadcrumb: [
            {
              name: '问题管理',
              path: '/problem-manage/problem-bench'
            },
            {
              name: '新建问题单据',
              path: '/problem-manage/create-problem-workflow'
            }
          ]
        },
        component: ProblemCreatePage
      },
      {
        path: 'change-bench',
        name: 'changeBench',
        meta: {
          roles: ['WF_CHANGE_QUERY'],
          title: '变更管理',
          icon: 'change-manage',
          activeMenu: '/change-manage/change-bench/',
          componentName: 'ChangeWorkbench',
          breadcrumb: [
            {
              name: '变更管理',
              path: '/change-manage/change-bench'
            }
          ]
        },
        component: ChangeWorkbench
      },
      {
        path: 'change-bench/edit-change-workflow/:id',
        props: true,
        name: 'editChangeWorkflow',
        meta: {
          roles: ['WF_CHANGE_DETAIL_QUERY'],
          title: '处理变更',
          hidden: true,
          activeMenu: '/change-manage/change-bench/',
          componentName: 'ChangeWorkflowDetail',
          breadcrumb: [
            {
              name: '变更管理',
              path: '/change-manage/change-bench'
            },
            {
              name: '处理变更',
              path: '/change-manage/edit-change-workflow/:id'
            }
          ]
        },
        component: ChangeWorkflowDetail
      },
      {
        path: 'change-bench/create-change-workflow',
        name: 'createChangeWorkflow',
        meta: {
          roles: ['WF_CHANGE_ADD'],
          title: '新建变更单据',
          hidden: true,
          activeMenu: '/change-manage/change-bench/',
          componentName: 'ChangeCreatePage',
          breadcrumb: [
            {
              name: '变更管理',
              path: '/change-manage/change-bench'
            },
            {
              name: '新建变更单据',
              path: '/change-manage/create-change-workflow'
            }
          ]
        },
        component: ChangeCreatePage
      },{
        path: 'change-bench/change-workflow-calendar',
        name: 'changeWorkflowCalendar',
        meta: {
          roles: ['WF_CHANGE_CALENDAR_QUERY'],
          title: '变更日历',
          hidden: true,
          activeMenu: '/change-manage/change-bench/',
          componentName: 'ChangeWorkflowCalendar',
          breadcrumb: [
            {
              name: '变更管理',
              path: '/change-manage/change-bench'
            },
            {
              name: '变更日历',
              path: '/change-manage/change-workflow-calendar'
            }
          ]
        },
        component: ChangeWorkflowCalendar
      },
      {
        path: 'release-bench',
        name: 'releaseBench',
        meta: {
          roles: ['WF_RELEASE_QUERY'],
          title: '发布管理',
          icon: 'release-manage',
          activeMenu: '/release-manage/release-bench/',
          componentName: 'ReleaseWorkbench',
          breadcrumb: [
            {
              name: '发布管理',
              path: '/release-manage/release-bench'
            }
          ]
        },
        component: ReleaseWorkbench
      },
      {
        path: 'release-bench/edit-release-workflow/:id',
        props: true,
        name: 'editReleaseWorkflow',
        meta: {
          roles: ['WF_RELEASE_DETIAL_QUERY'],
          title: '处理发布',
          hidden: true,
          activeMenu: '/release-manage/release-bench/',
          componentName: 'ReleaseWorkflowDetail',
          breadcrumb: [
            {
              name: '发布管理',
              path: '/release-manage/release-bench'
            },
            {
              name: '处理发布',
              path: '/release-manage/edit-release-workflow/:id'
            }
          ]
        },
        component: ReleaseWorkflowDetail
      },
      {
        path: 'release-bench/create-release-workflow',
        name: 'createReleaseWorkflow',
        meta: {
          roles: ['WF_RELEASE_ADD'],
          title: '新建发布单据',
          hidden: true,
          activeMenu: '/release-manage/release-bench/',
          componentName: 'ReleaseCreatePage',
          breadcrumb: [
            {
              name: '发布管理',
              path: '/release-manage/release-bench'
            },
            {
              name: '新建发布单据',
              path: '/release-manage/create-release-workflow'
            }
          ]
        },
        component: ReleaseCreatePage
      },
    ]
  }
];


// WEBPACK FOOTER //
// ./src/router/workOrder.js